import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '@components/controls/input/input.component';
import { DatesPickerComponent } from '@components/dates-picker/dates-picker.component';
import { LocaleDateComponent } from '@components/locale-date/locale-date.component';
import { StationNameComponent } from '@components/station-name/station-name.component';
import { StationPickerComponent } from '@components/station-picker/station-picker.component';
import { LetDirective } from '@directives/app-let.directive';
import { CancelCopy } from '@models/cms/cancel.model';
import { DurationPipe } from '@pipes/duration/duration.pipe';
import { BsModalRef } from 'ngx-bootstrap/modal';

/**
 * Component for choosing flights to modify, then triggering a search
 * with the modified dates, origins, and destinations. Modifies the booking
 * that has been put into state by retrieve.
 */
@Component({
  selector: 'app-confirm-cancel-flight-modal',
  standalone: true,
  imports: [
    LetDirective,
    CommonModule,
    LocaleDateComponent,
    DurationPipe,
    StationNameComponent,
    InputComponent,
    FormsModule,
    ReactiveFormsModule,
    StationPickerComponent,
    DatesPickerComponent,
  ],
  templateUrl: './confirm-cancel-flight-modal.component.html',
  styleUrls: ['./confirm-cancel-flight-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmCancelFlightModalComponent {
  @Input()
  cancelCmsCopy: CancelCopy;

  @Output()
  cancelOrContinue = new EventEmitter<boolean>();

  constructor(private bsModalRef: BsModalRef) {}

  cancel(): void {
    this.bsModalRef.hide();
    this.cancelOrContinue.emit(false);
  }

  continue(): void {
    this.bsModalRef.hide();
    this.cancelOrContinue.emit(true);
  }
}
